import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button, Paper } from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { serverMsg } from "../../config/messageconstant";
import { getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadExcel, downloadF } from "../PDF/PDFDownload";

import BeatTownDataImportPopUp from "./BeatTownImportPopUp";
const ExcelJS = require("exceljs");

class BeatTownImportExport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      importPopUpFlag: false,
    };
  }

  onClickOfExport = () => {
    const { showLoador, showNotification } = this.props;

    showLoador({ loador: true });
    downloadF({
      isGet: true,
      url: endpoint.exportData + "/beat-town-mapping-export-excel",
      ext: "xls",
      openNewTab: false,
      isShowSalesPersonName: true,
      reportName: "Beat-Town-Data",
    }).then((response) => {
      showLoador({ loador: false });
      if (!response) {
        showNotification({
          msg: serverMsg,
          severity: "error",
        });
      }
    });
  };

  onClickOfImport = () => {
    this.setState({ importPopUpFlag: true });
  };

  importPopUpClose = () => {
    this.setState({ importPopUpFlag: false });
  };

  render() {
    const { importPopUpFlag } = this.state;

    return (
      <>
        <Paper
          sx={{
            borderRadius: 2,
            p: { xs: 2, sm: 4 },
            boxShadow: "0 6px 32px rgba(0,0,0,0.08)",
            // background: "linear-gradient(135deg,rgb(251, 251, 251) 0%,rgb(238, 247, 250) 100%)",
            maxWidth: "auto",
            margin: "auto",
          }}
          elevation={5}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <LandingScreenHeader
              screenTitle="Beat Town Import-Export"
              showSaveBtnMain={false}
              showAddButton={false}
              showBackButton={false}
            />

            <div style={{ display: "flex", gap: 15 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="medium"
                startIcon={<CloudDownloadIcon />}
                sx={{
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "120px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#f4f6fa",
                    borderColor: "#1976d2",
                    color: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfExport}
              >
                Export
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                startIcon={<CloudUploadIcon sx={{ color: "#fff" }} />}
                sx={{
                  color: "#fff",
                  borderRadius: 2,
                  textTransform: "none",
                  fontWeight: 600,
                  transition: "all 0.2s",
                  minWidth: "150px",
                  height: "35px",
                  "&:hover": {
                    backgroundColor: "#1976d2",
                    transform: "translateY(-2px)",
                  },
                }}
                onClick={this.onClickOfImport}
              >
                Import
              </Button>
            </div>
          </div>

          {importPopUpFlag && (
            <BeatTownDataImportPopUp
              open={importPopUpFlag}
              handleCloses={this.importPopUpClose}
              dataMethod={this.dataMethod}
            />
          )}
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  salesPersonList: state.salesExecutive,
});

const mapDispatchToProps = {
  showLoador,
  showNotification,
  downloadExcel,
  getSalesExecutiveByUserType,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(BeatTownImportExport);
